<!--报表 客户毛利报表-->
<template>
  <div>
    <el-row>
      <el-col>
        <el-form :model="searchForm" ref="searchForm" :inline="true">
          <el-form-item label="分类：">
            <el-select v-model="searchForm.CATALOG_ID" clearable filterable>
              <el-option v-for="item in catalogList" :key="item.ID" :label="item.CATALOG_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="客户名称：">
            <el-select size="medium" filterable v-model="searchForm.TC_ID" placeholder="请选择客户" clearable>
              <el-option v-for="item in customer" :key="item.ID" :label="item.AB_NAME" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="日期范围：">
            <el-date-picker size="medium" v-model="searchForm.DATE" type="daterange" range-separator="至"
              start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="查询类型：">
            <el-select size="medium" filterable v-model="searchForm.查询类型" placeholder="请选择" clearable>
              <el-option v-for="item in 毛利表查询类型" :key="item.Stype" :label="item.NAME" :value="item.Stype"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" type="primary" class="btn" @click="fliterData">筛选</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportForm">导出</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportDailySummary">日汇总导出</el-button>
            <el-button size="medium" type="primary" plain class="btn" @click="exportByDate">分日期导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-table :data="tableData" max-height="520" stripe border>
          <!-- <el-table-column label="序号" type="index" width="50px"></el-table-column> -->
          <el-table-column label="类别" prop="TYPE_NAME" min-width="100px"></el-table-column>
          <el-table-column label="收入" prop="INCOME" min-width="100px"></el-table-column>
          <!-- <el-table-column v-for="item in kinds" :key="item.TYPE_ID" :label="item.TYPE_NAME" :prop="String(item.TYPE_ID)"></el-table-column> -->
          <el-table-column label="成本" prop="COST"></el-table-column>
          <el-table-column label="毛利" prop="PROFIT"></el-table-column>
          <el-table-column label="毛利率" prop="GROSS_MARGIN"></el-table-column>
          <el-table-column label="操作" fixed="right" width="70px">
            <template slot-scope="scope">
              <el-button v-if="scope.$index + 1 < tableData.length" type="text" @click="detail(scope.row)">
                查看
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import { queryTCProfit, exportTCTable } from 'api/returnWare';
import { haveDSXMDFun } from 'api/sellOrder';
import http from '@/assets/common/http';
import { getClassFun } from '@/assets/api/skuManage';
import util from '@/assets/common/util';

export default {
  data () {
    return {
      searchForm: {},
      tableData: [],
      kinds: [],
      customer: [],
      catalogList: [],
      毛利表查询类型: this.$util.毛利表查询类型(),
    };
  },
  created () {
    this.$set(this.searchForm, 'TC_ID', this.$store.state.TCGROSSPROFIT_ALL.TC_ID);
    this.$set(this.searchForm, 'DATE', this.$store.state.TCGROSSPROFIT_ALL.DATE);
    this.$set(this.searchForm, 'CATALOG_ID', this.$store.state.TCGROSSPROFIT_ALL.CATALOG_ID);
    this.queryData();
    this.queryPro();
    this.queryCatalog();
  },
  methods: {
    // ----拉取团餐公司
    queryPro () {
      haveDSXMDFun().then((result) => {
        this.customer = result.length > 0 ? result[0].company : [];
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 导出
    exportForm () {
      if (!(this.searchForm.DATE && this.searchForm.DATE[0])) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      exportTCTable(params).then((res) => {
        window.location.href = util.getURLLocalHost(res[0].FILE_PATH);
        this.exportDetailVisible = false;
        this.$message.show({ text: '导出成功', type: 'success' });
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    // 筛选
    fliterData () {
      this.queryData();
    },
    // 获取界面数据
    queryData () {
      this.$store.dispatch('TCGROSSPROFIT_ALL', { TC_ID: this.searchForm.TC_ID, DATE: this.searchForm.DATE, CATALOG_ID: this.searchForm.CATALOG_ID });
      const params = {
        PAGEINDEX: 0,
        PAGESIZE: 10 ** 10,
      };
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.DATE && this.searchForm.DATE[0]) {
        params.START_DAY = this.searchForm.DATE[0];
        params.END_DAY = this.searchForm.DATE[1];
      }
      if (this.searchForm.查询类型) {
        params.ORDER_SCALE = this.searchForm.查询类型;
      }
      queryTCProfit(params).then((result) => {
        this.tableData = result;
        // this.kinds = result[1].TYPE_LIST
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportDailySummary () {
      if (!(this.searchForm.DATE && this.searchForm.DATE[0])) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 66,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      http.post(params).then((res) => {
        if (res[0]) {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    exportByDate () {
      if (!(this.searchForm.DATE && this.searchForm.DATE[0])) {
        this.$message.show({ text: '请选择日期范围', type: 'warning' });
        return false;
      }
      const params = {
        SERVICE_ID: '10009',
        OTYPE: 65,
        GYS_ID: Number(sessionStorage.getItem('tcId')),
        START_DAY: this.searchForm.DATE[0],
        END_DAY: this.searchForm.DATE[1],
      };
      if (this.searchForm.PROJECT_ID) {
        params.PROJECT_ID = this.searchForm.PROJECT_ID;
      }
      if (this.searchForm.CATALOG_ID) {
        params.CATALOG_ID = this.searchForm.CATALOG_ID;
      }
      if (this.searchForm.TC_ID) {
        params.TC_ID = this.searchForm.TC_ID;
      }
      http.post(params).then((res) => {
        if (res[0]) {
          window.location.href = this.$util.getURLLocalHost(res[0].FILE_PATH);
        } else {
          this.$message.show({ text: '暂无数据', type: 'warning' });
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    queryCatalog () {
      getClassFun().then((result) => {
        if (result.length !== 0) {
          this.catalogList = result;
        } else {
          this.catalogList = [];
        }
      }).catch((error) => {
        this.$message.show({ text: error, type: 'error' });
      });
    },
    detail ({ TYPE_ID }) {
      const TC_ID = this.searchForm.TC_ID || 0;
      const DATE = this.searchForm.DATE || [];
      sessionStorage.setItem('TCGrossProfitDetailTitle', JSON.stringify({
        TC_ID, DATE, TYPE_ID,
      }));
      this.$router.push({ path: '/TCGrossProfitDetail/detail' });
    },
  },
};
</script>
<style scoped></style>



// WEBPACK FOOTER //
// src/components/tableManage/TCGrossProfit.vue